import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { IdtSharedRenderService } from 'render/render-shared/idt-shared-render.service';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceCardHoverRenderComponent } from './piece-card-hover-render.component';


export const pieceCardHoverRenderModuleEntryComponents = [
  PieceCardHoverRenderComponent
];
@NgModule({
  imports: [
    RenderSharedModule,
    RenderBlocksModule,
    SharedModule
  ],
  providers: [
    IdtSharedRenderService
  ],
  declarations: pieceCardHoverRenderModuleEntryComponents,
  exports: [PieceCardHoverRenderComponent]
})
export class PieceCardHoverRenderModule {}

export default pieceCardHoverRenderModuleEntryComponents;
